// extracted by mini-css-extract-plugin
var _1 = "PageHeader__PageHeader--AAWQ1";
export { _1 as "PageHeader" }
